module.exports = __webpack_public_path__ + "img/cp-event-depth.0b27e8f3.svg";